import React from "react";
import Card from "./Card";
import { ContentProviderResponse } from "../services/api.response.service";
import { Link } from "react-router-dom";
import { RouteEndpoints } from "../services/route.service";
import { useSelector } from "react-redux";
import { IRootState } from "../redux/states";

interface Props {
  data: ContentProviderResponse;
  showUnAuthModal?: () => void;
}

function ContentProviderCardSmall({
  data: { id, name, logo_url, description, address, country, other_details, link_name },
  showUnAuthModal,
}: Props) {
  const { ecampus_id } = useSelector(
    (state: IRootState) => state.setting.user!
  );
  return (
    <>
      <div className="d-flex flex-column justify-content-start align-items-start gap-1  ">
        {/*course-sub-details*/}
        <div className="d-grid d-md-flex gap-1 w-100"
             style={{
               fontSize: "11px",
               cursor: "pointer",
             }}
             onClick={() => {
               window.location.href = RouteEndpoints.CONTENT_PROVIDER_DETAIL(String(id));
             }}
        >
          <img alt="lang icon" className="rounded-full w-2 mt-1"
               src={logo_url}
               style={{
                 width: "25px",
                 height: "25px",
                 borderRadius: "50%",
                 objectFit: "cover",
               }} />
          <span className="m-1 details-fw"> {name ?? "NA"} </span>
        </div>
        <small className="m-1 one-line-ellipsis"
               style={{
                 wordWrap: "break-word",
                 overflow: "hidden",
                 maxHeight: "50px",
               }}>
          {description ?? "."}
        </small>
      </div>
    </>
  );
}

export default ContentProviderCardSmall;
